<template>
  <div class="ml_auction_list">
    <div class="ml_auction_list_fixed">
      <div class="ml_auction_list_fixed_item" @click="goToStatus()">
        <span style="font-size: 16px;font-weight: 600;">{{ navBarTitle }}</span>
        <span class="ml_auction_list_fixed_item_icon iconfont">&#xe658;</span>
      </div>
      <div class="ml_auction_list_fixed_item" @click="goToSearch()">
        <img width="20px" height="20px" class="ml_auction_list_fixed_item_search" src="../../assets/53.png" alt="">
      </div>
    </div>

    <div class="ml_auction_list_header">
      <div class="ml_auction_list_header_item" :class="{'ml_arrow_icon_active':status!=null}" @click="openScreenPopup(1)">
        <template v-for="(item, index) in tabList">
          <span :key="index" v-if="item.status == status">
            {{ item.label }}
          </span>
        </template>
        <span v-if="!isOpenDateField" class="iconfont">&#xe658;</span>
        <span v-if="isOpenDateField" class="iconfont">&#xe659;</span>
      </div>

      <div class="ml_auction_list_header_item" :class="{'ml_arrow_icon_active':orderId!=23691}" @click="openScreenPopup(0)">
        <!-- 排序 -->
        <template v-for="(item, index) in sortFields">
          <span :key="index" v-if="item.id == orderId">
            {{ item.name }}
          </span>
        </template>
        <span v-if="!isOpenSortField" class="iconfont">&#xe658;</span>
        <span v-if="isOpenSortField" class="iconfont">&#xe659;</span>
      </div>
    </div>

    <div class="ml_order_list">
      <div class="ml_order_count">
        共找到{{ carCount }}个车辆
      </div>
      <van-list v-model:loading="loading" :finished="finished" finished-text="没有更多了" :immediate-check="false"
        @load="$debounce(getAuctionList(),500)">
        <componentAuctionList :list="carList" :sid="sid"></componentAuctionList>
      </van-list>
    </div>

    <template v-if="carCount == 0">
      <componentNoData></componentNoData>
    </template>

    <!-- 时间筛选 -->
    <div class="ml_popup_screen" v-if="isOpenDateField" @click="closeDatetField">
      <div class="ml_popup_screen_content" style="padding-bottom: 15px;">
        <template v-for="(item, index) in tabList" :key="index">
          <div class="ml_popup_screen_item" @click="sortDateClick(item)">
            <div style="flex: 1;" :class="{ 'ml_popup_active': status == item.status }">
              {{ item.label }}
            </div>
            <template v-if="status == item.status">
              <span class="iconfont" style="color: #327FFF;">&#xe667;</span>
            </template>
          </div>
          <template v-if="item.status == 4">
            <div class="filter_date" @click="sortDateClick(item)">
              <span :style="{'color':createTime[0]?'#292D33':'#C0C0C0'}">{{ createTime[0]||'开始时间' }}</span>
               至 
              <span :style="{'color':createTime[1]?'#292D33':'#C0C0C0'}">{{ createTime[1]||'结束时间' }}</span>
            </div>
          </template>
        </template>
      </div>
    </div>
    <!-- 排序 -->
    <div class="ml_popup_screen" v-if="isOpenSortField" @click="closeSortField">
      <div class="ml_popup_screen_content">
        <div class="ml_popup_screen_item" v-for="(item, index) in sortFields" :key="index" @click="sortClick(item)">
          <div style="flex: 1;" :class="{ 'ml_popup_active': orderId == item.id }">
            {{ item.name }}
          </div>
          <template v-if="orderId == item.id">
            <span class="iconfont" style="color: #327FFF;">&#xe667;</span>
          </template>
        </div>
      </div>
    </div>


    <!-- 顶部筛选 -->
    <componentPopupSingleTop ref="screenTopPopup" v-model="gridType" :list="list" @change="onScreenChagne">
    </componentPopupSingleTop>

    <van-calendar ref="calendarRef" v-model:show="showCalendar" allow-same-day type="range" row-height="50px" :minDate="minDate" @select="onSelectAnyDay">
      <template #subtitle>
        <div class="custom_title">
          <div class="subtitle">
            <span :style="{'color':calendarDate[0]?'#292D33':'#C0C0C0'}">{{ calendarDate[0]||'开始时间' }}</span>
              至 
            <span :style="{'color':calendarDate[1]?'#292D33':'#C0C0C0'}">{{ calendarDate[1]||'结束时间' }}</span>
          </div>
        </div>
      </template>

      <template #footer>
        <div class="custom_footer">
          <van-button size="small" style="width: 100px;height: 42px;" round @click="handleReset">重置</van-button>
          <van-button size="small" type="primary" @click="handleConfirm" round style="flex:1;height: 42px;">确认</van-button>
        </div>
      </template>
    </van-calendar>

  </div>
</template>

<script>
import moment from 'moment'
import 'moment/locale/zh-cn'
moment.locale('zh-cn')

import componentPopupSingleTop from '@/components/componentPopupSingleTop.vue'
import componentNoData from "@/components/componentNoData.vue"
import componentAuctionList from '@/components/componentAuctionList.vue'

import {
  getListType, getAuctionList,
} from '@/utils/auction.js'


export default {
  components: {
    componentPopupSingleTop,
    componentNoData,
    componentAuctionList,
  },
  data() {
    return {
      currentType:null,
      isOpenSortField: false,

      sid:'',
      gridType: "",
      list: [],

      // 页码
      pageNum: 1,
      // 车辆列表
      carList: [],
      // 车辆总数
      carCount: 0,

      isOpenDateField:false,

      // 排序信息
      orderId: 23691,
      order: "",
      orderBy: "",
      sortFields: [
        {
          "id": 23691,
          "name": "最近发拍",
          "fieldId": "114",
          "fieldName": "send_time",
          "fieldLabel": "发拍时间",
          "orderBy": "desc",
          "isDefault": 0
        },
        {
          "id": 23692,
          "name": "里程最短",
          "fieldId": "115",
          "fieldName":
            "driven_distance",
          "fieldLabel": "表显里程",
          "orderBy": "asc",
          "isDefault": 0
        },
        {
          "id": 23693,
          "name": "起拍价格最低",
          "fieldId": "116",
          "fieldName": "starting_price",
          "fieldLabel": "起拍价格",
          "orderBy": "asc",
          "isDefault": 0
        },
        {
          "id": 23694,
          "name": "保留价格最低",
          "fieldId": "117",
          "fieldName": "reserve_price",
          "fieldLabel": "保留价格",
          "orderBy": "asc",
          "isDefault": 0
        }
      ],

      // 状态名称
      navBarTitle: "",

      loading: false,
      finished: false,

      showCalendar: false,
      minDate: new Date(1990, 0, 1),
      createTime: [],
      calendarDate:[],
      
      currentStatus:null,
      status:null,
      tabList:[
        {
          status:null,
          label:"总览"
        },
        {
          status:1,
          label:"本月"
        },
        {
          status:2,
          label:"本季"
        },
        {
          status:3,
          label:"本年"
        },
        {
          status:4,
          label:"自定义"
        },
      ]
    };
  },
  mounted() {
    const that = this
    that.sid = that.$route.query.sid;
    that.status = that.$route.query.status;
    that.currentStatus = that.$route.query.status;
    that.storeId = that.$route.query.storeId || null;
    that.currentStoreId = that.$route.query.storeId || null;
    that.gridType = that.$route.query.gridType || 0;
    that.currentType = that.$route.query.gridType || 0;
    that.getListType()
    that.getAuctionList()
  },
  activated() {
    if(this.$route.query.gridType != this.currentType || this.$route.query.status != this.currentStatus ||this.$route.query.storeId != this.currentStoreId ){
      const that = this
      that.sid = that.$route.query.sid;
      that.status = that.$route.query.status;
      that.currentStatus = that.$route.query.status;
      that.storeId = that.$route.query.storeId || null;
      that.currentStoreId = that.$route.query.storeId || null;
      that.gridType = that.$route.query.gridType || 0;
      that.currentType = that.$route.query.gridType || 0;

      that.pageNum = 1;
      that.orderId = 23691,
      that.order = ""
      that.orderBy = ""
      that.loading = false
      that.finished = false
      that.showCalendar = false
      that.minDate = new Date(1990, 0, 1)
      that.createTime = []
      that.calendarDate = []
      that.carList = []
      that.getListType()
      that.$debounce(that.getAuctionList(),500)
    }
  },
  methods: {
    fetchData() {
      const that = this
      that.sid = that.$route.query.sid;
      that.status = that.$route.query.status;
      that.gridType = that.$route.query.gridType || 0;
      that.currentType = that.$route.query.currentType || 0;
      that.getListType()
    },
    onScreenChagne(e) {
      const that = this
      that.navBarTitle = e.gridName
      that.gridType = e.gridType;
      that.onRefresh();
    },
    onRefresh() {
      // 刷新
      const that = this;
      that.carList = [];
      that.carCount = 0;
      window.scrollTo(0, 0);

      that.loading = false
      that.finished = false
      that.pageNum = 1;
      that.getAuctionList();
    },
    goToStatus() {
      // 状态
      this.$refs.screenTopPopup.openPopup();
    },
    goToSearch() {
      // 搜索
      const that = this
      that.$router.push({
        path: "/auctionsearch",
        query: {
          order: that.order,
          orderBy: that.orderBy,
          gridType: that.gridType*1,
          storeId:that.storeId,
          searchFilter: JSON.stringify(that.searchFilter),
          sid:that.sid
        }
      });
    },
    openScreenPopup(e) {
      const that = this;
      switch (e) {
        case 0:
          // 排序
          that.isOpenSortField = !that.isOpenSortField;
          break;
        case 1:
          // 时间类筛选
          that.isOpenDateField = !that.isOpenDateField
          break;
      }
    },
    closeDateField() {
      this.isOpenDateField = false;
    },
    sortDateClick(e){
      if(e.status == 4){
        this.showCalendar = true
        return
      }else{
        this.calendarDate = []
        this.createTime = []
      }
      this.status = e.status
      this.closeDateField();
      this.onRefresh();
    },
    closeSortField() {
      this.isOpenSortField = false;
    },
    sortClick(e) {
      // 排序
      this.orderId = e.id;
      this.order = e.orderBy;
      this.orderBy = e.fieldName;

      this.closeSortField();
      this.onRefresh();
    },
    onSelectAnyDay(value){
      let arr = []
      value.map(e=>{
        arr.push(moment(e).format('YYYY-MM-DD'))
      })
      this.calendarDate = arr
    },
    handleReset() {
      this.calendarDate = []
      this.$refs.calendarRef.reset()
    },
    handleConfirm() {
      let result = []
      this.$refs.calendarRef.getSelectedDate().map(e=>{
        result.push(moment(e).format('YYYY-MM-DD'))
      })
      this.createTime = result
      this.showCalendar = false
      this.isOpenDateField = false
      this.status = 4
      this.onRefresh()
    },
    getAuctionList() {
      // 车辆列表
      const that = this;

      that.loading = true
      getAuctionList({
        keywords: "",
        storeId:that.storeId,
        createTime: that.createTime,
        gridType: that.gridType,
        pageNum: that.pageNum,
        pageSize: 10,
        order: that.order,
        orderBy: that.orderBy,
        rangeType:that.status
      }).then(res => {
        if (that.pageNum == 1) {
          that.carList = res.data.list;
        } else {
          that.carList = that.carList.concat(res.data.list);
        }

        that.carCount = res.data.total;

        that.pageNum++
        that.loading = false
        if (that.carList.length >= that.carCount) {
          that.finished = true;
        }

        that.$nextTick()
      })
    },
    getListType() {
      const that = this;
      getListType({storeId:that.storeId}).then(res => {
        res.data.map(e => {
          if (e.gridType == that.gridType) {
            that.navBarTitle = e.gridName;
          }
        })
        that.list = res.data;
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.ml_auction_list {
  min-height: 100vh;
  background: #f5f7f9;

  .ml_auction_list_fixed {
    height: 56px;
    background: #ffffff;
    border-bottom: 1px solid #f5f7f9;
    display: flex;
    justify-content: space-between;
    position: sticky;
    top: 0;
    z-index: 1;

    .ml_auction_list_fixed_item {
      font-size: 14px;
      padding:8px 15px;
      display: flex;
      align-items: center;


      .ml_auction_list_fixed_item_icon {
        font-size: 8px;
        margin-left: 5px;
      }
    }
  }

  .ml_auction_list_header {
    height: 44px;
    background: #ffffff;
    display: flex;
    justify-content: space-between;

    .ml_auction_list_header_item {
      width: 50%;
      height: 44px;
      font-size: 14px;
      display: flex;
      align-items: center;
      justify-content: center;
      .iconfont{
        font-size: 10px;
      }
    }

    .ml_arrow_icon_active {
      color: #327FFF;
      .iconfont{
        font-size: 10px;
      }
    }
  }

  .ml_order_list {
    .ml_order_count {
      font-size: 12px;
      color: #979797;
      padding: 10px 15px;
    }
  }

  .custom_title{
    width: calc( 100% - 50px );
    margin:0 auto;
    .subtitle{
      height: 35px;
      border: 1px solid rgba(50,127,255,1);
      border-radius: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 14px;
      font-weight: 400;
      span{
        flex: 1;
      }
    }
  }
  .custom_footer {
    display: flex;
    padding: 8px;
    gap: 8px;
    border-top: 0.5px solid rgba(233,233,233,1);
  }
  .van-calendar__footer{
    padding: 0;
  }
  .filter_date{
    height: 40px;
    background: #F7F7F7;
    border-radius: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    span{
      flex-grow: 1;
      text-align: center;
    }
  }
  .ml_popup_screen {
    position: fixed;
    top: 100px;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.45);

    .ml_popup_screen_content {
      background-color: #FFFFFF;
      border-bottom-left-radius: 16px;
      border-bottom-right-radius: 16px;
      padding: 0 15px;

      .ml_popup_screen_item {
        height: 50px;
        line-height: 50px;
        border-top: 0.5px solid #E9E9E9;
        font-size: 14px;
        color: #292D33;
        display: flex;

        .ml_popup_active {
          color: #327FFF;
          font-weight: bold;
        }
      }
    }
  }
}
</style>